






export const  extractIds = (data, key = "_id") => {
  // Check if data is not an array or is empty
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  // Check the type of the first element in the array
  const firstElement = data[0];

  // Case 1: Array of strings (e.g., ["123", "123456"])
  if (typeof firstElement === "string") {
    return data.map(id => ({ [key]: id }));
  }

  // Case 2 & 3: Array of objects (e.g., [{_id: "123"}, {_id: "123456"}] or [{_id: "123", name: "viswa"}, ...])
  if (typeof firstElement === "object" && firstElement !== null) {
    return data
      .map(item => item[key] || null)
      .filter(id => id !== null);
  }

  // Default: Return empty array if the format is unrecognized
  return [];
};